<footer>
  <div class="footer-content">
    <span class="content">
      <img src="./assets/images/logo-leonus.png" alt="logo" />
      <span
        >Registered <span class="app-name">LEONUS</span> Banking
        {{ currentYear | date : "yyyy" }}</span
      >
    </span>
    <span> Version: 1.2.4</span>
  </div>
</footer>
